import { SIQLauncherUnreadBadgeTheme } from "./SIQLauncherUnreadBadgeTheme";
export class SIQChatScrollButtonTheme {
  iconColor = "null";
  backgroundColor = "null";
  UnreadBadge = new SIQLauncherUnreadBadgeTheme();
}
//# sourceMappingURL=SIQChatScrollButtonTheme.js.map